import { PromptTemplateCategory } from '../types';

export const educational: PromptTemplateCategory = {
  title: "Edukatif",
  icon: "🧠",
  templates: [
    {
      title: "Jelaskan dengan Sederhana",
      content: `Jelaskan topik [bagaimana vaksin melatih sistem kekebalan tubuh] dengan cara yang jelas dan menarik untuk pendengar.
- Bayangkan Anda menjelaskannya kepada [seorang remaja yang penasaran tanpa latar belakang sains].
- Gunakan analogi yang relatable: [bandingkan dengan latihan kebakaran — kamu berlatih untuk sesuatu agar siap saat hal nyata terjadi].
- Hindari jargon; ketika istilah teknis diperlukan, definisikan segera dalam bahasa sederhana.
- Tulis dengan nada hangat dan mendorong yang membuat pendengar merasa pintar, bukan direndahkan.`
    },
    {
      title: "Voiceover Dokumenter",
      content: `Tulis narasi voiceover gaya dokumenter.
- Subjek: [kehidupan sehari-hari pedagang makanan kaki lima di Bangkok].
- Sudut pandang: [keahlian, kebanggaan, dan pengetahuan turun-temurun di balik hidangan yang terlihat sederhana tapi butuh bertahun-tahun untuk dikuasai].
- Nada: [hormat, hidup, dan tidak terburu-buru — biarkan adegan bernapas].
- Sertakan detail sensorik yang membantu pendengar membayangkan dan merasakan lingkungan: [suara mendesis wok, kelembaban pasar pagi, gerakan tangan yang presisi dari pedagang yang telah melakukan ini sepuluh ribu kali].
- Tulis dalam kala kini untuk kedekatan.`
    },
    {
      title: "Meditasi Terpandu",
      content: `Tulis skrip meditasi terpandu yang dirancang untuk didengarkan.
- Tujuan: [melepaskan ketegangan setelah hari kerja yang panjang dan memasuki malam dengan tenang].
- Pandu pendengar untuk memvisualisasikan [tepi danau yang tenang saat matahari terbenam — cahaya hangat di atas air, angin sepoi-sepoi, suara burung-burung jauh yang bersarang untuk malam].
- Nada: [tenang, tidak terburu-buru, dan membumi].
- Durasi bicara perkiraan: [8 menit].
- Gunakan banyak jeda alami (ditandai dengan "...") antara instruksi. Jaga kalimat tetap pendek dan lembut. Hindari perubahan energi yang tiba-tiba.`
    }
  ]
};
